import styled from "@emotion/styled";
import type { PropsWithChildren } from "react";
import { MDSText, MDSTextColor, MDSTextVariant } from "@/mds";
import type { MDSTextProps } from "@/mds/components/text/text/text.types";

export const StateWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 64px 46px;
  gap: 16px;
`;

const DescriptionText = styled(MDSText)`
  max-width: 320px;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

type TextProps = PropsWithChildren<MDSTextProps>;

export const HeadsUpStateText = ({ children, ...rest }: TextProps) => {
  return (
    <DescriptionText variant={MDSTextVariant.TextS} color={MDSTextColor.Secondary} {...rest}>
      {children}
    </DescriptionText>
  );
};
